import React from 'react';
import styled from 'styled-components';
import { Icons, ImpContainer, ImpFlex, ImpIcon, ImpPad, } from '../..';
import { colors } from '../../DesignSystem/colors';
const getBannerColor = (colorStyle = 'color', defaultColor = colors.background.backgroundInverse) => {
    switch (colorStyle) {
        case 'imprint':
            return colors.background.backgroundInverse;
        case 'branded':
            return 'var(--merchant-color)';
        case 'alert':
            return colors.content.onSurfaceError;
        default:
            return defaultColor;
    }
};
const getRightActionIcon = (actionType) => {
    switch (actionType) {
        case 'dismiss':
            return Icons.close;
        case 'navigate':
            return Icons.arrowRight;
        default:
            return undefined;
    }
};
const RightIconWrapper = styled(ImpContainer) `
  margin-left: auto;
`;
/**
 * A banner component with various customization options.
 *
 * @param {React.ReactNode} props.children - The child components contained in the banner except the right icon.
 * @param {ImpBannerActionType} [props.actionType='dismiss'] - The type of the right icon ("dismiss", "navigate", "none").
 * @param {ImpBannerColorStyle} [props.colorStyle='imprint'] - The color style of the banner ("imprint", "branded", "color").
 * @param {string} [props.padding='16px'] - The padding of the banner.
 * @param {string} [props.borderRadius] - The border radius of the banner.
 * @param {string} props.color - The color of the banner.
 * @param {() => void} props.onBannerClick - The onClick function of the entire banner.
 * @param {() => void} props.onRightIconClick - The onClick function of the right icon.
 *
 * @returns The ImpBanner component.
 */
export default function ImpBanner({ children, actionType = 'dismiss', colorStyle, padding = '16px', borderRadius, color, onBannerClick, onRightIconClick, }) {
    const rightActionIcon = getRightActionIcon(actionType);
    return (React.createElement(ImpContainer, { width: "100%", backgroundColor: getBannerColor(colorStyle, color), borderRadius: borderRadius, onClick: onBannerClick, dataTestId: "banner-container" },
        React.createElement(ImpPad, { padding: padding },
            React.createElement(ImpFlex, { align: "center", justify: "space-between", fluid: true, gap: "l" },
                children,
                React.createElement(RightIconWrapper, { onClick: onRightIconClick, dataTestId: "right-icon-container" }, rightActionIcon && (React.createElement(ImpPad, { padding: "12px" },
                    React.createElement(ImpIcon, { stroke: colors.content.onBackgroundInverse, iconSrc: rightActionIcon, dataTestId: "right-icon" }))))))));
}
//# sourceMappingURL=ImpBanner.js.map